module.exports = Jsw.skinUrl + "/images/notification-center-empty.svg?681835d816561968b04d20ec8652c09c";